import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import requesticon from "../../../assets/images/requesticon.png";
import { LinkedCameraOutlined } from "@material-ui/icons";
import FeatureContainer from "./featureContainer/FeatureContainer";

export const ActivitySection = ({ payload }) => {
  return (
    <section className="feature-section import-section ">
      <div className="row">
        {payload.length != 0 ? (
          <div className="row">
            <FeatureContainer
              columnClass="col-12 col-lg-6 col-md-6"
              logo={payload[0].uploadedLogo.filePath}
              title={payload[0].title}
              details={payload[0].details}
            />

            <FeatureContainer
              columnClass="col-12 col-lg-3 col-md-6"
              logo={payload[1].uploadedLogo.filePath}
              title={payload[1].title}
              details={payload[1].details}
            />

            <FeatureContainer
              columnClass="col-12 col-lg-3 col-md-6"
              logo={payload[2].uploadedLogo.filePath}
              title={payload[2].title}
              details={payload[2].details}
            />

            <FeatureContainer
              columnClass="col-12 col-lg-3 col-md-6"
              logo={payload[3].uploadedLogo.filePath}
              title={payload[3].title}
              details={payload[3].details}
            />

            <FeatureContainer
              columnClass="col-12 col-lg-6 col-md-6"
              logo={payload[4].uploadedLogo.filePath}
              title={payload[4].title}
              details={payload[4].details}
            />

            <div className="col-12 col-lg-3 col-md-6 ">
              <div className="import-tile-container ">
                <div className="feature-container-item2 import-tile import-tile-request demo-ft">
                  <div className="import-tile-header">
                    <img alt="" src={requesticon} />
                  </div>
                  <Link
                    to="/signup"
                    type="button"
                    className="request-btn  bold hero-section-button integration-content-button"
                  >
                    <div className="white fs-19 request-demo-btn" id="reqdemo">
                      <h5>Request Demo</h5>
                      <h5 className="fs-24 mx-2 mt-1">
                        <FontAwesomeIcon icon={faAngleRight} />
                      </h5>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
};
